import React from 'react';

const CHIP = {
  aprobado: { label: 'ARCA · Aprobado', state: 'aprobado' },
  valid: { label: 'ARCA · Validado', state: 'aprobado' },
  observado: { label: 'ARCA · Observado', state: 'observado' },
  observed: { label: 'ARCA · Observado', state: 'observado' },
  rechazado: { label: 'ARCA · Rechazado', state: 'rechazado' },
  rejected: { label: 'ARCA · Posible fraude', state: 'rechazado' },
  error: { label: 'ARCA · Error al validar', state: 'observado' },
  skipped_missing_fields: { label: 'ARCA · Datos insuficientes', state: 'observado' },
  not_enabled: { label: 'ARCA · Desactivado', state: 'sin' },
  pending: { label: 'ARCA · Validando', state: 'checking' },
  sin_constatar: { label: 'ARCA · Sin constatar', state: 'sin' },
};

export default function ArcaChip({ arca, loading = false }) {
  const key = loading ? 'checking' : arca?.state || arca?.status || 'sin_constatar';
  const cfg = CHIP[key] || CHIP.sin_constatar;
  const dataState = loading ? 'checking' : cfg.state;

  return (
    <span className="dv-arca-chip" data-s={dataState}>
      <span className="dv-arca-chip-dot" />
      <span>{loading ? 'Consultando ARCA…' : cfg.label}</span>
    </span>
  );
}
